import { render, staticRenderFns } from "./QueueDeleteModal.vue?vue&type=template&id=06493bf4&scoped=true"
import script from "./QueueDeleteModal.vue?vue&type=script&lang=js"
export * from "./QueueDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06493bf4",
  null
  
)

export default component.exports